import type { RefObject } from 'react';
import { ArrowForward } from '@mui/icons-material';
import {
  AssistiveText,
  KeyCap,
  NavigationCancel,
  NavigationContext,
  NavigationIcon,
  NavigationOverlay,
  NavigationProgress,
  NavigationTarget,
  NavigationTitle,
} from './SuperSearch.styles';
import { SUPER_SEARCH_TEST_IDS } from './SuperSearch.testIds';
import type { SuperSearchPendingNavigation, SuperSearchShortcut } from './SuperSearch.types';

interface SuperSearchNavigationStatusProps {
  cancelButtonRef: RefObject<HTMLButtonElement | null>;
  navigation: SuperSearchPendingNavigation;
  onCancel: () => void;
  pressedShortcut?: SuperSearchShortcut;
}

const SuperSearchNavigationStatus = ({
  cancelButtonRef,
  navigation,
  onCancel,
  pressedShortcut,
}: SuperSearchNavigationStatusProps) => (
  <NavigationOverlay data-testid={SUPER_SEARCH_TEST_IDS.navigation}>
    <AssistiveText aria-atomic="true" aria-live="polite" role="status">
      Navigating to {navigation.label} in {navigation.context}. Press Escape to cancel.
    </AssistiveText>
    <NavigationIcon aria-hidden tone={navigation.tone}>
      <ArrowForward />
    </NavigationIcon>
    <NavigationTitle>Navigating to {navigation.typeLabel}</NavigationTitle>
    <NavigationTarget tone={navigation.tone}>{navigation.label}</NavigationTarget>
    <NavigationContext>{navigation.context}</NavigationContext>
    <NavigationProgress tone={navigation.tone} />
    <NavigationCancel aria-label={`Cancel navigation to ${navigation.label}`} onClick={onCancel} ref={cancelButtonRef}>
      Cancel
      <KeyCap data-pressed={pressedShortcut === 'close' || undefined}>esc</KeyCap>
    </NavigationCancel>
  </NavigationOverlay>
);

export default SuperSearchNavigationStatus;
